function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.03 40.25v-.54c0-.85.4-1.62 1.02-2.12V18.27l-.98-.38a1.68 1.68 0 010-3.13L23.4 6.12c.4-.16.83-.16 1.23 0l22.3 8.64a1.68 1.68 0 010 3.13l-7.9 3.07V34.7c0 .45-.11.84-.26 1.18-.74 1.61-2.96 3-5.32 3.93A26.02 26.02 0 0124 41.57c-3.6 0-6.9-.74-9.44-1.75-2.36-.94-4.57-2.32-5.31-3.93a2.98 2.98 0 01-.2-.55l-.02-.25-.02-.04c-.02-.1-.03-.22-.03-.34V20.96l-3.55-1.38V37.4a2.74 2.74 0 011.29 2.31v.54A2.76 2.76 0 013.95 43H3.8a2.76 2.76 0 01-2.77-2.75z"
})));